import {
  ExclusionType,
  IExclusionOption,
  SearchQueryConditionsFields,
} from './search-query-form.models';

export const SEARCH_QUERY_CONDITIONS_FIELD_VALUES: readonly SearchQueryConditionsFields[] =
  [
    'names',
    'roles',
    'affiliations',
    'workSettings',
    'industries',
    'expertise',
    'publications',
    'boardCertifications',
    'clinicalTrials',
    'treatments',
    'medicalConditions',
  ];

export const EXCLUSION_OPTIONS: readonly IExclusionOption[] = [
  {
    value: 'payers',
    label: 'Payers',
    terms: ['pharmacy director', 'medical director'],
  },
  {
    value: 'nurses',
    label: 'Nurses',
    terms: ['nurse', 'nursing'],
  },
  {
    value: 'paediatricians',
    label: 'Paediatricians',
    terms: ['paediatrician', 'paediatric'],
  },
  {
    value: 'medical-doctors',
    label: 'Medical doctors',
    terms: [
      'physician',
      'medical doctor',
      'doctor of medicine',
      'general practitioner',
      'surgeon',
      'hospitalist',
      'intensivist',
      'internist',
      'cardiologist',
      'oncologist',
      'neurologist',
      'endocrinologist',
      'gastroenterologist',
      'pulmonologist',
      'rheumatologist',
      'infectious disease specialist',
      'paediatrician',
      'psychiatrist',
      'radiologist',
      'pathologist',
      'anesthesiologist',
      'obstetrician',
      'gynecologist',
      'dermatologist',
      'nephrologist',
      'urologist',
      'orthopedic surgeon',
      'ent specialist',
      'ophthalmologist',
    ],
  },
  {
    value: 'lab-directors',
    label: 'Lab directors',
    terms: [
      'laboratory director',
      'laboratory manager',
      'laboratory supervisor',
      'blood bank director',
      'clinical pathology director',
      'cytology director',
      'histology director',
      'molecular diagnostics director',
      'quality manager',
    ],
  },
  {
    value: 'healthcare-admins',
    label: 'Healthcare admins',
    terms: [
      'healthcare administrator',
      'hospital administrator',
      'practice administrator',
      'clinic administrator',
      'healthcare executive',
      'chief executive officer',
      'chief operating officer',
      'chief administrative officer',
      'operations director',
      'practice manager',
      'office manager',
      'clinic manager',
      'hospital manager',
      'healthcare operations manager',
      'administrative director',
      'service line director',
      'patient services director',
      'revenue cycle director',
      'billing manager',
      'healthcare compliance officer',
      'quality improvement manager',
      'care coordination manager',
      'patient access manager',
      'scheduling manager',
      'health administrator',
      'network administrator',
      'care administrator',
    ],
  },
];

export const EXCLUSION_LABEL_MAP: Readonly<Record<ExclusionType, string>> =
  EXCLUSION_OPTIONS.reduce(
    (labelMap, option) => ({
      ...labelMap,
      [option.value]: option.label,
    }),
    {} as Record<ExclusionType, string>
  );

export const DEFAULT_EXCLUDE_ROLES: readonly ExclusionType[] = [
  'payers',
  'nurses',
  'paediatricians',
  'medical-doctors',
  'lab-directors',
  'healthcare-admins',
];

export const WORK_SETTINGS_OPTIONS: readonly string[] = [
  'Hospital',
  'Academic Hospital',
  'Community Hospital',
  'Private Practice',
  'Pharmacy (retail)',
  'Pharmacy (hospital)',
  'Retail',
  'Lab',
  'Medical device company',
  'Pharmaceutical company',
  'Biotech company',
  'GPO',
  'IDN',
  'MCO',
  'PBM',
  'Government',
  'Telehealth',
];
